"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));
var _objectDestructuringEmpty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectDestructuringEmpty"));
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var _slice = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/slice"));
var _react = _interopRequireDefault(require("react"));
var _formik = require("formik");
var _FormikFieldComponent = require("./FormikFieldComponent");
var stripNonDigits = function stripNonDigits(x) {
  return x.replace(/[^\d]/g, '');
};
var formatPhoneNumber = function formatPhoneNumber(value) {
  var _context2, _context3;
  if (!value) {
    return '';
  }
  var onlyNums = stripNonDigits(value);
  if (onlyNums.length <= 3) {
    return onlyNums;
  }
  if (onlyNums.length <= 7) {
    var _context;
    return (0, _concat["default"])(_context = "(".concat((0, _slice["default"])(onlyNums).call(onlyNums, 0, 3), ") ")).call(_context, (0, _slice["default"])(onlyNums).call(onlyNums, 3));
  }
  return (0, _concat["default"])(_context2 = (0, _concat["default"])(_context3 = "(".concat((0, _slice["default"])(onlyNums).call(onlyNums, 0, 3), ") ")).call(_context3, (0, _slice["default"])(onlyNums).call(onlyNums, 3, 6), "-")).call(_context2, (0, _slice["default"])(onlyNums).call(onlyNums, 6, 10));
};
var parsePhoneNumber = function parsePhoneNumber(value) {
  if (!value) {
    return '';
  }
  return stripNonDigits(value);
};
var FormikFormPhoneNumber = function FormikFormPhoneNumber(_ref) {
  var props = (0, _extends2["default"])({}, ((0, _objectDestructuringEmpty2["default"])(_ref), _ref));
  var _useField = (0, _formik.useField)(props),
    _useField2 = (0, _slicedToArray2["default"])(_useField, 3),
    setValue = _useField2[2].setValue;
  return /*#__PURE__*/_react["default"].createElement(_formik.Field, (0, _extends2["default"])({
    type: "tel",
    component: _FormikFieldComponent.FormikFieldComponent,
    placeholder: "(555) 555-5555",
    onChange: function onChange(event) {
      setValue(formatPhoneNumber(event.target.value));
    },
    autoComplete: "tel",
    label: "Phone Number",
    maxLength: "14"
  }, props));
};
FormikFormPhoneNumber.formatPhoneNumber = formatPhoneNumber;
FormikFormPhoneNumber.parsePhoneNumber = parsePhoneNumber;
var _default = exports["default"] = FormikFormPhoneNumber;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-react-components/lib/FormikFormPhoneNumber.js
// module id = 4376
// module chunks = 25